export const ROUTES = Object.freeze({
  main: '/',
  deepLink: '/qrcode',
  siteConsents: '/new-careteam',
  policyUpdate: '/policy-update',
  auth: {
    intro: '/auth',
    login: {
      login: '/auth/login',
      pin: '/auth/login/pin',
      accountLoader: '/auth/login/account-loader',
      instanceConnection: '/auth/login/instance-connection',
      emailVerify: '/auth/login/email-verify',
      forgotPassword: '/auth/login/forgot-password',
    },
    register: {
      index: '/auth/register',
      consents: '/auth/register/consents',
      email: '/auth/register/email',
      password: '/auth/register/password',
      verify: '/auth/register/verify',
      birthday: '/auth/register/birthday',
      name: '/auth/register/name',
      gender: '/auth/register/gender',
      authenticate: '/auth/register/authenticate',
      confirmProfile: '/auth/register/confirm-profile',
    },
  },
  dashboard: {
    index: '/dashboard',
    home: '/dashboard/home',
    medication: '/dashboard/medication',
    appointment: '/dashboard/appointment',
    stats: '/dashboard/stats',
    settings: {
      index: '/dashboard/settings',
      security: '/dashboard/settings/security',
      language: '/dashboard/settings/language',
      imprint: '/dashboard/settings/imprint',
      notifications: '/dashboard/settings/notifications',
      health: {
        options: '/dashboard/settings/health/options',
        settings: '/dashboard/settings/health/settings/:type/:secondType',
      },
      myoncare: '/dashboard/settings/myoncare',
      deleteAccount: '/dashboard/settings/deleteAccount',
      profile: '/dashboard/settings/profile',
    },
    files: {
      index: '/dashboard/files',
      preview: '/dashboard/files/preview',
    },
    careTeams: {
      list: '/dashboard/careteam',
      details: {
        index: '/dashboard/careteam-details/:siteUUID',
        chat: '/dashboard/careteam-details/:siteUUID/chat/:sourceProjectId',
      },
    },
  },
  security: {
    pin: '/security/pin',
    deactivatePin: '/security/deactivate-pin',
  },
  answering: '/dashboard/home/tasks/:siteUuid/:taskId/answering',
  medicationPlan: '/dashboard/medication/plan',
  maintenancePage: '/maintenance',
  update: '/update',
});
